// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__3hBRp","notes":"Notes_notes__1wGJt","note":"Notes_note__noy6d","markdown":"Notes_markdown__12hKI"};